exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filter-container[data-v-15505d7d] {\n  padding-bottom: 10px;\n}\n.filter-item[data-v-15505d7d] {\n  margin-right: 10px;\n}\n", ""]);

// exports
